import { render, staticRenderFns } from "./Deadline.vue?vue&type=template&id=3b4a8d70"
import script from "./Deadline.vue?vue&type=script&lang=js"
export * from "./Deadline.vue?vue&type=script&lang=js"
import style0 from "./Deadline.vue?vue&type=style&index=0&id=3b4a8d70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports